import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PinwheelModal from '@pinwheel/react-modal';

import {
  INCOME_VERIFICATION_PROVIDER_PINWHEEL,
} from 'common/incomeVerificationConstants';

import {
  SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
  SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL,
} from 'api/actionTypes';

import log from 'client/lib/log';
import postWithState from 'client/actions/postWithState';
import withLocationQuery from 'client/helpers/withLocationQuery';
import branch from 'client/core/branch';

import SrBox from 'client/components/SrBox';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';

@withLocationQuery
@branch()
class SrPinwheelProofOfConceptPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Pinwheel POC | Sunroom Rentals',
  })

  static propTypes = {
    locationQuery: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      screeningToken: null,
    };
  }

  _onStartIncomeVerificationClick = async () => {
    const { locationQuery, dispatch } = this.props;
    const incomeVerificationUserId = parseInt(locationQuery.userId || 1821, 10);
    const incomeVerificationListingId = parseInt(locationQuery.listingId || 431123, 10);

    const incomeVerificationGroup = await dispatch(postWithState, {
      action: SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
      payload: {
        userIds: [incomeVerificationUserId],
        listingId: incomeVerificationListingId,
        provider: INCOME_VERIFICATION_PROVIDER_PINWHEEL,
      },
    });

    const incomeVerification = incomeVerificationGroup.incomeVerifications.find(({ userId }) => {
      return userId === incomeVerificationUserId;
    });

    if (incomeVerification) {
      const screeningToken = await dispatch(postWithState, {
        action: SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL,
        payload: {
          incomeVerificationId: incomeVerification.id,
        },
      });
      this.setState({
        screeningToken,
      });
    }
    else {
      this.setState({
        screeningToken: null,
      });
    }
  }

  _onPinwheelEvent = (pinwheelEvent) => {
    log.info('Pinwheel event:');
    log.info(pinwheelEvent);
  }

  render() {
    const {
      screeningToken,
    } = this.state;

    return (
      <div>
        {screeningToken &&
          <SrBox position='relative'>
            <SrBox>
              <PinwheelModal
                linkToken={screeningToken}
                onEvent={this._onPinwheelEvent}
                open
              />
            </SrBox>
          </SrBox>
        }

        {!screeningToken &&
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            onClick={this._onStartIncomeVerificationClick}
          >
            Start Income Verification
          </SrButton>
        }
      </div>
    );
  }
}

SrPinwheelProofOfConceptPage.displayName = 'SrPinwheelProofOfConceptPage';

export default SrPinwheelProofOfConceptPage;
